import _styled from "@emotion/styled/base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

import { jsx as _jsx } from "@emotion/react/jsx-runtime";

var MobileNav = function MobileNav(_ref) {
  var children = _ref.children;
  return _jsx(Wrapper, {
    children: children
  });
};

var Wrapper = /*#__PURE__*/_styled("nav", true ? {
  target: "e1oxa5i10"
} : {
  target: "e1oxa5i10",
  label: "Wrapper"
})(true ? {
  name: "10syivw",
  styles: "position:sticky;top:0;left:0;z-index:999;width:100%"
} : {
  name: "10syivw",
  styles: "position:sticky;top:0;left:0;z-index:999;width:100%",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi93b3JrZGlyL2xpYnMvbWF0Y2hhL3JlY2lwZXMvTmF2aWdhdGlvbjIvTW9iaWxlTmF2aWdhdGlvbi9Nb2JpbGVOYXZpZ2F0aW9uLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNMEIiLCJmaWxlIjoiL3dvcmtkaXIvbGlicy9tYXRjaGEvcmVjaXBlcy9OYXZpZ2F0aW9uMi9Nb2JpbGVOYXZpZ2F0aW9uL01vYmlsZU5hdmlnYXRpb24udHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHR5cGUgeyBGQywgUHJvcHNXaXRoQ2hpbGRyZW4gfSBmcm9tICdyZWFjdCdcblxuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5cbmNvbnN0IE1vYmlsZU5hdjogRkM8UHJvcHNXaXRoQ2hpbGRyZW4+ID0gKHsgY2hpbGRyZW4gfSkgPT4gPFdyYXBwZXI+e2NoaWxkcmVufTwvV3JhcHBlcj5cblxuY29uc3QgV3JhcHBlciA9IHN0eWxlZC5uYXZgXG4gIHBvc2l0aW9uOiBzdGlja3k7XG4gIHRvcDogMDtcbiAgbGVmdDogMDtcbiAgei1pbmRleDogOTk5O1xuICB3aWR0aDogMTAwJTtcbmBcblxuZXhwb3J0IGRlZmF1bHQgTW9iaWxlTmF2XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

export default MobileNav;